<template>
  <div>
    <div v-if="isActive" class="petition-form wwf-form light">
      <div class="flip-wrapper" :class="{ 'formValidation-shake' : isShake }">
        <div class="petition-form">

          <h2 v-if="title">{{title}}</h2>
  
          <p v-if="intro" class="form-intro" v-html="intro"></p>
  
          <input name="firstName" type="text" v-model="firstName" v-validate="'required'" :class="{'border-red': errors.has('firstName')}" placeholder="First name">
          <input name="lastName" type="text" v-model="lastName" v-validate="'required'" :class="{'border-red': errors.has('lastName')}" placeholder="Last name">
          <input name="twitchName" type="text" v-model="twitchName" v-validate="'required'" :class="{'border-red': errors.has('twitchName')}" placeholder="Twitch name">

          <input name="email" type="email" v-model="email" v-validate="'required|email'" :class="{'border-red': errors.has('email')}" placeholder="Email">
  
          <input name="phone" type="number" v-validate="'numeric'" v-model="phone" :class="{'border-red': errors.has('phone')}" placeholder="Phone">
  
          <input name="postCode" type="number" v-model="postCode" placeholder="Postcode">
  
          <div class="privacy-statement">
            <p>By signing you accept
              <a href="/privacy-policy/privacy-policy" target="_blank">WWF-Australia&rsquo;s Privacy Policy.</a>
            </p>
          </div>
          <input type="button" v-on:click="save" value="Submit" />
  
        </div>
      </div>
  
    </div>
  
    <div v-if="!isActive" class="form-closed">
      <p>{{closingmessage}}</p>
    </div>
  
  </div>
</template>

<script>

export default {
  name: "my-twitchForm",
  props: {
    title: {
      //thankyoutitle="Test title"
      type: String,
      required: false
    },
    intro: {
      //intro="Test intro"
      type: String,
      required: false
    },
    isActive: {
      //:is-active="false"
      type: Boolean,
      required: true
    },
    thankyoutitle: {
      //thankyoutitle="Test title"
      type: String,
      required: true
    },
    thankyoumessage: {
      //thankyoumessage="Test message"
      type: String,
      required: true
    },
    datalayername: {
      //datalayername="Test datalayer name"
      type: String,
      required: true
    },
    closingmessage: {
      //closingmessage="Test the compatition has closed."
      type: String,
      default: "This competition has now closed."
    },
    programname: {
      //petitionname="Test petition name"
      type: String,
      required: true
    },
    keepData: {
      //:keep-data="false"
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      isShake: false,
      firstName: "",
      lastName: "",
      twitchName: "",
      email: "",
      phone: "",
      postCode: "",
      isLoading: false
    };
  },
  methods: {
    save: function() {
      this.$validator.validateAll().then(result => {
        if (result) {
          console.log("Twitch form valid", result);

          var date = new Date();

          var postBody = {
            email: this.email,
            firstName: this.firstName,
            lastName: this.lastName,
            twitchName: this.twitchName,
            postcode: this.postCode,
            phone: this.phone,
            programName: this.programname,
            createdDate: date.toISOString(),
            cookieID: this.$cookie.get("_mkto_trk"),
            keepData: this.keepData
          };

          this.$store
            .dispatch("saveLead", {
              campaignId: this.datalayername,
              lead: postBody
            })
            .then(
              response => {
                console.log("Twitch success");

                if (window.dataLayer != undefined) {
                  window.dataLayer.push({
                    formName: this.datalayername,
                    event: "formSubmitSuccessEvent"
                  });
                }

                //Reset form
                this.firstName = "";
                this.lastName = "";
                this.email = "";
                this.twitchName = "";
                this.phone = "";
                this.postCode = "";
              },
              error => {
                console.error("Twitch error:", error);
              }
            );

          this.$store.commit("setPopupContent", {
            title: this.thankyoutitle,
            message: this.thankyoumessage,
            shareButton: true,
            recommendedReading: false,
            component: null,
            componentparams: null
          });
          this.$store.commit("openPetitionPopup", true);
        } else {
          console.log("Twitch form invalid", result);
          // GTM Tracking
          if (window.dataLayer != undefined) {
            window.dataLayer.push({
              formName: this.datalayername,
              event: "formSubmitEvent"
            });
          }
          this.isShake = true;
          setTimeout(
            function() {
              this.isShake = false;
            }.bind(this),
            500
          );
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// TwitchForm.vue?1c9d3698